import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './products-model.js';

const defaultHandler = (state = INITIAL_STATE) => state;

const fetched = (state, { data }) => ({
  ...state,
  products: data.items,
  totalCount: data.totalCount,
});

const productFetched = (state, { data }) => ({
  ...state,
  productToUpdate: data,
});

const openModal = (state) => ({
  ...state,
  isModalOpen: true,
});

const closeModal = (state) => ({
  ...state,
  isModalOpen: false,
  productToUpdate: INITIAL_STATE.productToUpdate,
});

const setFilters = (state, { filters }) => ({
  ...state,
  filters: {
    ...state.filters,
    ...filters,
  },
});

const fetchedHighlighted = (state, { data }) => ({
  ...state,
  highlightedProducts: data,
});

const clearId = (state) => ({
  ...state,
  productToUpdate: {
    ...state.productToUpdate,
    id: null,
  },
});

const setStoreFilters = (state, { filters }) => ({
  ...state,
  storeFilters: {
    ...state.storeFilters,
    ...filters,
  },
});

const fetchedStore = (state, { data }) => ({
  ...state,
  storeProducts: data.items,
  storeTotalCount: data.totalCount,
});

export const { Types, Creators } = createActions({
  // Management
  productsFetched: ['data'],
  productFetched: ['data'],
  productOpenModal: [],
  productCloseModal: [],
  productClearId: [],
  productsSetFilters: ['filters'],
  productsFetchAsync: ['filters'],
  productFetchByIdAsync: ['id', 'isClone'],
  productCreateAsync: ['data'],
  productUpdateAsync: ['id', 'data'],
  productDeleteAsync: ['id'],

  productsSetStoreFilters: ['filters'],
  productsFetchStoreAsync: ['filters'],
  productsFetchedStore: ['data'],

  // Store
  productsFetchedHighlighted: ['data'],
  productsFetchHighlightedAsync: [],
});

export default createReducer(INITIAL_STATE, {
  // Management
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.PRODUCTS_FETCHED]: fetched,
  [Types.PRODUCT_FETCHED]: productFetched,
  [Types.PRODUCT_OPEN_MODAL]: openModal,
  [Types.PRODUCT_CLOSE_MODAL]: closeModal,
  [Types.PRODUCTS_SET_FILTERS]: setFilters,
  [Types.PRODUCT_CLEAR_ID]: clearId,

  [Types.PRODUCTS_SET_STORE_FILTERS]: setStoreFilters,
  [Types.PRODUCTS_FETCHED_STORE]: fetchedStore,

  // Store
  [Types.PRODUCTS_FETCHED_HIGHLIGHTED]: fetchedHighlighted,
});
